import { Link } from 'react-router-dom'
import { TopBar } from '../components/TopBar'
import { useApp } from '../store/AppContext'
import { AdultMovedHomeTiles } from '../components/AdultMovedHomeTiles'
import { adultHomeTiles, loadAdultHomePrefs } from '../lib/adultHomePrefs'

const information = [
  { to: '/care-menu', label: 'Menu & recipes', desc: 'Plan meals and open accessible recipes', tone: 'bg-[#fff2e7] text-[#b85f2b]', icon: '🍲' },
  { to: '/documents', label: 'Documents', desc: 'Plans, reports and shared files', tone: 'bg-[#edf4ff] text-[#3765b2]', icon: '▤' },
  { to: '/funding', label: 'Funding', desc: 'Plan funding and remaining amounts', tone: 'bg-[#e9f7f4] text-[#238e88]', icon: '$' },
  { to: '/therapy-updates', label: 'Therapy updates', desc: 'Information shared by my therapy team', tone: 'bg-[#eef3f7] text-[#53657a]', icon: '✎' },
  { to: '/support-strategies', label: 'Support strategies', desc: 'Useful support information for my team', tone: 'bg-[#fff5dc] text-[#b7791f]', icon: '✦' },
  { to: '/settings', label: 'Settings', desc: 'View, notifications and account settings', tone: 'bg-[#e8f7f5] text-[#249a96]', icon: '⚙' },
]

export function AdultParticipantMore() {
  const { currentUser } = useApp()
  const prefs = loadAdultHomePrefs(currentUser.id, 'alex')
  const movedPaths = new Set<string>(adultHomeTiles.alex.filter(tile => !prefs.visible.includes(tile.id)).map(tile => tile.to))

  return <div className="min-h-screen bg-[#f5f8fb] pb-28 text-slate-900">
    <TopBar title="More" subtitle="Everything that doesn’t need to sit on Today" />
    <div className="space-y-4 px-3.5 py-4">
      <AdultMovedHomeTiles profile="alex" userId={currentUser.id}/>

      <section>
        <p className="px-1 text-[10px] font-black uppercase tracking-[.12em] text-[#245a9d]">Information & support</p>
        <div className="mt-3 grid grid-cols-2 gap-3">{information.filter(item => !movedPaths.has(item.to)).map(item => <Link key={item.to} to={item.to} className="min-w-0 rounded-[20px] border border-slate-200 bg-white p-3.5 shadow-[0_5px_18px_rgba(15,23,42,.05)] transition active:scale-[.99]"><div className={`flex h-10 w-10 items-center justify-center rounded-[14px] text-base font-black ${item.tone}`}>{item.icon}</div><p className="mt-3 text-sm font-black">{item.label}</p><p className="mt-1 text-[10px] font-semibold leading-4 text-slate-500">{item.desc}</p></Link>)}</div>
      </section>

      <Link to="/switch-user" className="flex items-center gap-3 rounded-[20px] border border-slate-200 bg-white p-4 shadow-[0_5px_18px_rgba(15,23,42,.05)]"><div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#eef3f7] text-[#53657a]">↔</div><div className="min-w-0 flex-1"><p className="text-sm font-black">Switch account</p><p className="text-xs font-semibold text-slate-500">Change to another role or profile</p></div><span className="text-slate-400">→</span></Link>
    </div>
  </div>
}

